import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface FiltersState {
    filtersOpen: boolean;
    path: string;
}

const initialState: FiltersState = {
    filtersOpen: false,
    path: ''
};

const filtersSlice = createSlice({
    name: 'dataTableSearch',
    initialState,
    reducers: {
        setFiltersOpen: (state, action: PayloadAction<boolean>) => {
            state.path = window.location.pathname;
            state.filtersOpen = action.payload;
        },
    }
});

export const {setFiltersOpen} = filtersSlice.actions;
export default filtersSlice.reducer;
